<div class="actions-dropdown__info">
  <div class="actions-dropdown__loading" *ngIf="(!!isUploading && !!disableControls) || !!hasOngoingMigrationActivity">
    <img src="assets/images/loading/spinner-dotted.svg" class="loader" alt="loader"/>
    <p [innerHTML]="isUploading ? 'Uploading the zip file…' : (ongoingMigrationActivity?.meta?.is_clone ? 'Site cloning in progress...' : 'Site migration in progress…')"></p>
  </div>
  <div class="actions-dropdown db-main__icons"
       [dsTooltip]="actionsList"
       [dsTooltipMode]="'hoverStatic'"
       [dsTooltipHoveredElement]="'.actions-dropdown'"
       dsTooltipPosition="bottom" [dsTooltipSize]="'large'"
       dsTooltipAlign="right" dsTooltipFont="regular"
       [hostClass]="'default'"
       [ngClass]="{'hovered': !!toggled}">
    <span>{{ 'text_sideBarAddWebsite' | dbText}}</span> <i class="db-icon db-icon-ds-arrow-sharp" [ngClass]="{'toggled': toggled}"></i>
  </div>
</div>


 <ng-template #actionsList>

   <div class="db-websites-controls-actions-list"
        [ngClass]="{'disable': !!disableControls}">

     <div *ngIf="(!!isUploading && !!disableControls) || !!hasOngoingMigrationActivity" class="db-websites-controls-actions__loading">
       <img src="assets/images/loading/spinner-dotted.svg" class="loader inside" alt="loader"/>
       <div>
         <b [innerHTML]="isUploading ? 'Uploading the zip file…' : (ongoingMigrationActivity?.meta?.is_clone ? 'Site cloning in progress...' : 'Site migration in progress…')"></b>
         <p class="mt4" [innerHTML]="ongoingMigrationActivity?.meta?.is_clone ? 'You can create websites once cloning is<br/> complete' : 'You can add websites once migration<br/>is complete.'"></p>
       </div>
     </div>

    <!-- <db-websites-controls-card
       *ngIf="userSubscription?.plan?.services?.hosting"
       [icon]="'ds-ai'"
       [title]="'text_generateWebsiteWithAI' | dbText"
       [ngClass]="{'disabled': disableControls}"
       [disabled]="disableControls"
       (click)="!disableControls && openCreateWebsiteModal('Dashboard: Websites list: Generate website with AI')"></db-websites-controls-card>
-->

     <db-websites-controls-card
       *ngIf="hasHostingService && !userSubscription?.trialBoosterClient && !userSubscription?.boosterProClient"
       [icon]="'ds-create-plus'"
       [title]="'text_createNewWebsite' | dbText"
       [ngClass]="{'disabled': disableControls}"
       [disabled]="disableControls"
       (click)="!disableControls && openCreateWebsiteModal('Dashboard: Websites list: Create Blank Wordpress website')"></db-websites-controls-card>




   </div>

   <!--<div class="db-buy-additional-website"
        *ngIf="!userSubscription?.apiResellerFree && !userSubscription?.isDedicatedVM && ![clientRoles.COMPANY_DEV, clientRoles.SITE_DEV].includes(workspaceRole)
  && userSubscription?.plan?.additionalDomainParameterPrice
  && (userSubscription?.isBusiness || userSubscription?.isEcommerce || userSubscription?.isAgency
   || (!userSubscription?.boosterProClient && userSubscription?.type === userSubscriptionType.PLATFORM))">
     <div class="db-buy-additional-website__info">
       <b [innerHTML]="'text_buyAdditionalWebsite' | dbText"></b>
       <p [innerHTML]="'text_buyAdditionalWebsiteDesc' | dbText: {price: (additionalWebsitePrice | roundNumber), repeat: 'month'}"></p>
     </div>
     <a class="ds-btn-white-gray-border white-bg ds-btn-s m short"
        [ngClass]="{'ds-btn-disabled': userSubscription?.status === UserSubscriptionStatus?.canceled}"
        (click)="userSubscription?.status !== UserSubscriptionStatus?.canceled && buyNow()">
       <span>{{'buy now' | lowerCaseSpecificWords}}</span>
     </a>
   </div>-->

   <div class="db-buy-additional-website"
        *ngIf="workspaceRole !== clientRoles.SITE_DEV && userSubscription?.type !== UserSubscriptionCategory?.DedicatedVM && !userSubscription?.trialBoosterClient && userSubscription?.type !== UserSubscriptionType.BOOSTER
     && userSubscription?.plan?.type !== UserSubscriptionType.ONE_PRODUCT
     && userSubscription?.plan?.type !== UserSubscriptionType.PREMIUM && !demoUser">
     <div class="db-buy-additional-website__info">
      <p [innerHTML]="'text_websiteOf' | dbText:{out: userSubscription?.type === UserSubscriptionType.PLATFORM ? hostedAndSpeedWebsitesCount : hostedWebsitesWithMultiCount, of: hostingLimit}"></p>
     </div>
   </div>

 </ng-template>
